import { useState } from "react"

export const ColumnSortTrigger = ({ onClick, currentSortBy, sortBy, localStorageKey, label }) => {
    const [direction, setDirection] = useState(0);

    const handleClick = () => {
        let newDirection;

        if (sortBy === currentSortBy) {
            // i.e. we are clicking in the same column as before then just change the direction
            newDirection = direction === 0 ? 1 : 0;
        }
        else {
            // we are changing the column - default direction to zero
            newDirection = 0;
        }
        onClick(newDirection)

        localStorage.setItem(localStorageKey, JSON.stringify({
            sortBy: sortBy,
            sortDirection: newDirection
        }))

        setDirection(newDirection)
    }
    return (
        <div role="button" onClick={ () => handleClick() } className='d-flex align-items-center'>
            { label }
            <div className="d-flex flex-column ml-2">
                {
                    currentSortBy !== sortBy ?
                        <>
                            <i className="fas fa-chevron-up fs--2 m-0"></i>
                            <i className="fas fa-chevron-down fs--2 m-0"></i>
                        </>
                        : <i className={ `fas fa-chevron-${ direction === 1 ? "up" : "down" } fs--2 m-0` }></i>
                }
            </div>
        </div>
    )
}